// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2xuXE","colCheckbox":"styles_colCheckbox__3_Z3g"};